const isEmptyObject = (obj: any) => JSON.stringify(obj) === '{}';

export default isEmptyObject;
